// src/components/Skills.js
import React from "react";

function Skills() {
  const skills = [
    // --- Core Programming & DS stack ---
    { name: "Python",  },
    { name: "R",  },
    { name: "SQL / MySQL",  },
    { name: "C++",  },
    { name: "MATLAB",  },
    { name: "JavaScript",  },

    // --- ML / AI / DL ---
    { name: "Machine Learning",  },
    { name: "Deep Learning",  },
    { name: "Text Classification",  },
    { name: "Logistic Regression",  },
    { name: "Random Forests",  },
    { name: "Gradient Boosting / XGBoost",  },
    { name: "NLP",  },
    { name: "Chatbot Development",  },
    { name: "Generative AI",  },
    { name: "Computer Vision",  },

    // --- Feature work / data prep ---
    { name: "Data Preprocessing",  },
    { name: "Feature Engineering",  },
    { name: "SMOTE",  },
    { name: "Feature Selection",  },
    { name: "Scaling & Normalization",  },
    { name: "Regularization (L1/L2)",  },

    // --- Evaluation / stats / DS-core (extra 16-ish DS skills) ---
    { name: "Exploratory Data Analysis (EDA)",  },
    { name: "A/B Testing",  },
    { name: "Hypothesis Testing",  },
    { name: "Bayesian Inference",  },
    { name: "Cross-Validation",  },
    { name: "Hyperparameter Tuning",  },
    { name: "Model Evaluation & Metrics",  },
    { name: "Model Interpretation",  },
    { name: "SHAP",  },
    { name: "Model Monitoring",  },
    { name: "Model Deployment",  },
    { name: "APIs / REST",  },

    // --- Time series & quant / finance ---
    { name: "Time Series Analysis",  },
    { name: "ARIMA",  },
    { name: "GARCH",  },
    { name: "Value-at-Risk (VaR)",  },
    { name: "Retail Sales Analysis",  },
    { name: "Credit Risk Modelling",  },
    { name: "Business Analytics",  },
    { name: "Investment Strategies",  },
    { name: "Financial Analysis",  },
    { name: "Financial Modeling & Valuation",  },

    // --- Tools & platforms ---
    { name: "RStudio",  },
    { name: "Power BI",  },
    { name: "Tableau",  },
    { name: "Excel (Advanced)",  },
    { name: "PowerPoint",  },
    { name: "Word",  },
    { name: "Git / Version Control",  },
    { name: "Docker",  },
    { name: "Linux",  },
    { name: "AWS",  },
    { name: "Hadoop",  },
    { name: "Apache Spark",  },
    { name: "VBA / Macros",  },

    // --- Business & communication ---
    { name: "Business Understanding",  },
    { name: "Client Communication",  },
    { name: "Data Visualization",  },
    { name: "Hypothesis Framing",  },
    { name: "Leadership",  },
    { name: "Team Management",  },
    { name: "Cross-functional Leadership",  },
    { name: "Decision-Making",  },
    { name: "Public Speaking",  },

    // --- Product / design / misc ---
    { name: "Front-End Development",  },
    { name: "UI / UX",  },
    { name: "Figma",  },
    { name: "WordPress",  },
    { name: "Event Management",  },
    { name: "Editorial",  },
    { name: "Design",  },

    // --- Misc tech from your list ---
    { name: "Blockchain",  },
    { name: "OrCAD Capture CIS",  },
    { name: "Object-Oriented Programming (OOP)",  },
    { name: "Computer Ethics",  },
    { name: "Artificial Intelligence (AI)",  },
  ];

  return (
    <div className="section-content skills-section">
      <h1>Skills</h1>
      <p className="section-intro">
        A snapshot of my technical, analytical, and leadership skills across
        data science, machine learning, quant, and engineering.
      </p>

      <div className="skills-grid">
        {skills.map((skill) => (
          <div className="skill-card" key={skill.name}>
            {skill.icon && (
              <img
                src={skill.icon}
                alt={skill.name}
                className="skill-icon"
              />
            )}
            <span className="skill-name">{skill.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;
